import React, { useMemo, useState } from 'react'
import { collection, limit, onSnapshot, orderBy, query } from 'firebase/firestore'
import { db } from '../../firebase-config'

function fmt(ts) {
  const d = ts?.toDate ? ts.toDate() : new Date(ts)
  if (!d || Number.isNaN(d.getTime())) return '-'
  return d.toLocaleString('es-AR')
}

export default function SupportAuditLog() {
  const [logs, setLogs] = useState([])
  const [ticketsMap, setTicketsMap] = useState({})
  const [loading, setLoading] = useState(true)
  const [ticketCodeFilter, setTicketCodeFilter] = useState('')
  const [adminFilter, setAdminFilter] = useState('')

  React.useEffect(() => {
    const qLogs = query(collection(db, 'ticket_audit_log'), orderBy('timestamp', 'desc'), limit(120))
    const qTickets = query(collection(db, 'tickets'), limit(200))

    const unsubLogs = onSnapshot(qLogs, (snap) => {
      setLogs(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
      setLoading(false)
    }, () => setLoading(false))

    const unsubTickets = onSnapshot(qTickets, (snap) => {
      const map = {}
      snap.docs.forEach((d) => {
        const row = d.data() || {}
        map[d.id] = row.ticketCode || d.id
      })
      setTicketsMap(map)
    })

    return () => {
      unsubLogs()
      unsubTickets()
    }
  }, [])

  const filtered = useMemo(() => {
    const ticketNeedle = ticketCodeFilter.trim().toLowerCase()
    const adminNeedle = adminFilter.trim().toLowerCase()
    return logs.filter((l) => {
      const ticketCode = String(ticketsMap[l.ticketId] || l.ticketId || '').toLowerCase()
      const admin = String(l.adminId || '').toLowerCase()
      if (ticketNeedle && !ticketCode.includes(ticketNeedle)) return false
      if (adminNeedle && !admin.includes(adminNeedle)) return false
      return true
    })
  }, [logs, ticketsMap, ticketCodeFilter, adminFilter])

  return (
    <section className="rounded-xl border border-slate-800 bg-slate-900 p-4 shadow-sm">
      <h3 className="text-lg font-bold text-cyan-100">Auditoria de Soporte</h3>
      <p className="mt-1 text-sm text-slate-300">Caja negra de cambios de estado en tickets.</p>

      <div className="mt-3 grid gap-2 md:grid-cols-2">
        <input
          type="text"
          value={ticketCodeFilter}
          onChange={(e) => setTicketCodeFilter(e.target.value)}
          placeholder="Filtrar por ticketCode"
          className="rounded border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-100"
        />
        <input
          type="text"
          value={adminFilter}
          onChange={(e) => setAdminFilter(e.target.value)}
          placeholder="Filtrar por adminId"
          className="rounded border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-100"
        />
      </div>

      {loading && <p className="mt-3 text-sm text-slate-400">Cargando auditoria...</p>}
      {!loading && filtered.length === 0 && <p className="mt-3 text-sm text-slate-400">Sin eventos para los filtros actuales.</p>}

      <div className="mt-3 space-y-2">
        {filtered.map((l) => (
          <div key={l.id} className="rounded-lg border border-slate-700 bg-slate-950 p-3">
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded bg-slate-800 px-2 py-0.5 text-xs font-semibold text-slate-200">{ticketsMap[l.ticketId] || l.ticketId || '-'}</span>
              <span className="rounded bg-cyan-950 px-2 py-0.5 text-xs text-cyan-300">{l.action || 'STATUS_CHANGE'}</span>
            </div>
            <p className="mt-1 text-xs text-slate-300">Admin: {l.adminId || '-'} · {fmt(l.timestamp)}</p>
            <p className="text-xs text-slate-200">Estado: {l?.details?.from || '-'} → {l?.details?.to || '-'}</p>
            <p className="text-xs text-slate-300">Normativa: {l?.details?.versionNormativa || 'desconocida'}</p>
            {l?.details?.sentiment_hint && (
              <p className="text-xs text-slate-300">Tipo: {l.details.sentiment_hint}</p>
            )}
          </div>
        ))}
      </div>
    </section>
  )
}
